
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/features/sale",
      function () {
        return require("private-next-pages/phone/features/sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/features/sale"])
      });
    }
  